import { useSyncExternalStore } from 'react';
import { Capacitor } from '@capacitor/core';

/** Running inside the Android app (Capacitor), not a browser. */
export const isNative = Capacitor.isNativePlatform();

// Phones get the map-first shell; tablets and desktops keep the website layout.
const NARROW = '(max-width: 767px)';

function subscribe(onChange: () => void) {
  const mq = window.matchMedia(NARROW);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}

/** true in the Android app and on narrow screens: use the map-first mobile shell. */
export function useMobileShell(): boolean {
  const narrow = useSyncExternalStore(subscribe, () => window.matchMedia(NARROW).matches, () => false);
  return isNative || narrow;
}

/** The public link for a shared trip. In the app the page's own origin is https://localhost. */
export function tripLink(code: string, apiUrl: string): string {
  return isNative ? apiUrl : `${window.location.origin}/trip/${code}`;
}
